import { IonSpinner } from '@ionic/react';
import React, { Suspense } from 'react';
import { AgentChatMarkdown } from '../agentChat/AgentChatMarkdown';
import { CanvasTab, InCanvasProvider, useCanvas } from './CanvasContext';
import './Canvas.scss';

// The resolver is a large page, so it is only pulled in once a DJ opens it.
const DuplicateResolverPage = React.lazy(
  () => import('../../pages/duplicates/DuplicateResolverPage'),
);

const CanvasBody: React.FC<{ tab: CanvasTab }> = ({ tab }) => {
  if (tab.kind === 'duplicates') {
    // The real Duplicate Resolver, not a second copy of it. With no router
    // state to read it falls back to loading the groups over IPC itself.
    return <DuplicateResolverPage embedded />;
  }

  if (tab.kind === 'table' && tab.markdown) {
    return (
      <div className="canvas-table">
        <AgentChatMarkdown content={tab.markdown} />
      </div>
    );
  }

  return null;
};

export const CanvasSurface: React.FC = () => {
  const canvas = useCanvas();
  const active = canvas?.tabs.find((tab) => tab.id === canvas.activeId);
  if (!active) return null;

  return (
    <div className="canvas-surface">
      <InCanvasProvider value={true}>
        <Suspense
          fallback={
            <div className="canvas-loading">
              <IonSpinner name="crescent" />
            </div>
          }
        >
          <CanvasBody tab={active} />
        </Suspense>
      </InCanvasProvider>
    </div>
  );
};

export default CanvasSurface;
